import { PropsWithChildren, ReactNode, useState } from "react";
import { Box, Button, Form } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { ModalProps } from "../ModalManager";

export type ConfirmModalProps = {
  onConfirm: () => any;

  title: string;
  subtitle: string;
  description: ReactNode;
  confirmButtonText: string;
} & ModalProps;

export function ConfirmModal({ ...props }: PropsWithChildren<ConfirmModalProps>) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <Box>
      <p className="title">
        {props.children}
        &nbsp;&nbsp;
        <span>{props.title}</span>
      </p>
      <p className="subtitle">{props.subtitle}</p>
      <Form.Field>
        <Form.Control>
          {props.description}
        </Form.Control>
      </Form.Field>
      <Form.Field className="is-grouped">
        <Form.Control>
          <Button color="danger" loading={loading} disabled={loading} onClick={() => { setLoading(true); props.onConfirm(); }}>
            {props.confirmButtonText}
          </Button>
        </Form.Control>
        <Form.Control>
          <Button className="is-ghost has-text-info" onClick={props.closeModal}>
            {t("cancel")}
          </Button>
        </Form.Control>
      </Form.Field>
    </Box>
  );
}
